
<template>
  <div>
      <div style="width:1300px;margin:0 auto;margin-top:100px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   销售汇总
                </span>
               
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
              
                   <div class="row ml-2 mb-2">
                     <div class="col-lg-7">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                 <div class="col-lg-5">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                          开始时间:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                        <date7 @changeDate="changeDate1($event)"/>
                                  </div> 
                                  </div>   
                               </div>
                               <div class="col-lg-5">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                          结束时间:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                       <date6 class="picker2"  @changeDate="changeDate2($event)"/>
                                  </div> 
                                  </div>   
                               </div>
                             
                                 </div>
                                   
                             </div>
                               
                          </div>
                       </div>
                        <div class="col-lg-5">
                          <div class="row ml-lg-3">            
                                 <button class="bg-primary button_zi heit" @click="getClerkStoreGoodsQuery()">查询</button>
                                 <button class="bg-success button_zi ml-lg-5" @click="exportExcel()">导出查询EXCEL</button>
                               
                      </div>
                  </div>
                </div>    
            <div v-if="showPage">
                        <table class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>公司</th>
                        <!-- <th>毛利</th> -->
                        <th>今年销售额</th>
                        <th>去年销售额</th>
                        <th>完成率</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.brachNo | company}}</td>
                              <!-- <td class="jz_middle">{{item.profit}}</td> -->
                              <td class="jz_middle" :class="item.amount>item.lAmount?'bj_red':''">{{item.amount}}</td>
                              <td class="jz_middle" :class="item.lAmount>item.amount?'bj_red':''">{{item.lAmount}}</td>
                              <td style="font-weight:500">{{((item.amount/item.lAmount)*100).toFixed(2)}}%</td>
                      </tr>
                      <tr class="text-center">
                          <td class="jz_middle" style="font-weight:600">合计:</td> 
                          <td class="jz_middle">查询的今年总的销售:<span class="ml-2" :class="toTalAmount>lToTalAmount?'bj_red':''" style="font-weight:600;font-size:16px;">{{toTalAmount}}</span></td>
                          <td class="jz_middle">查询的去年总的销售:<span class="ml-2" :class="lToTalAmount>toTalAmount?'bj_red':''" style="font-weight:600;font-size:16px;">{{lToTalAmount}}</span></td>
                          <td style="font-weight:500">{{((toTalAmount/lToTalAmount)*100).toFixed(2)}}%</td>
                      </tr>
                    </tbody>
                  </table>
                    <table style="float:left;width:25%;margin-top:20px;border-top:2px solid;" class="table table-striped table-hover" ref="print">
                    <thead>
                            <tr style="white-space: nowrap;" class="text-center">
                              <th>月份</th>
                            </tr>
                    </thead>
                      <tbody>
                      <tr v-for="(item,index) in yfDate" :key="index" class="text-center">
                              <td>{{item}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table style="float:left;width:25%;margin-top:20px;border-top:2px solid;" class="table table-striped table-hover" ref="print">
                    <thead>
                            <tr style="white-space: nowrap;" class="text-center">
                              <th>今年的销售额（万元）</th>
                            </tr>
                    </thead>
                      <tbody>
                      <tr v-for="(item,index) in thisYearData" :key="index" class="text-center">       
                              <td>{{(item.amount/10000).toFixed(2)}}</td>
                      </tr>
                    </tbody>

                  </table>
                   <table style="float:left;width:25%;margin-top:20px;border-top:2px solid;" class="table table-striped table-hover" ref="print">
                    <thead>
                            <tr style="white-space: nowrap;" class="text-center">
                              <th>去年的销售额（万元）</th>
                            </tr>
                    </thead>
                      <tbody>
                      <tr v-for="(item,index) in lastYearData" :key="index" class="text-center">
                              <td>{{(item.amount/10000).toFixed(2)}}</td>
                      </tr>
                    </tbody>
                  </table>
                   <table style="float:left;width:25%;margin-top:20px;border-top:2px solid;" class="table table-striped table-hover" ref="print">
                    <thead>
                            <tr style="white-space: nowrap;" class="text-center">
                              <th>完成率</th>
                            </tr>
                    </thead>
                      <tbody>
                      <tr v-for="(item,index) in wclv" :key="index" class="text-center">
                              <td style="font-weight:500">{{item}}</td>
                      </tr>
                    </tbody>
                  </table>

 
            </div>
           

                  <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>



                <p class="text-center">
                    <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->
                   

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../../components/Pagination.vue"
import Loading from '../../components/Loading.vue'
import date6 from '../../components/Date/Date6.vue'
import date7 from '../../components/Date/Date7.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          //supplierNum:"",
         DateMoreThan: '',
          DateLessThan: '' ,
            DateLessThan1: '',
          DateMoreThan1: '',// 今天+1
        },//搜索内容
        isLoading: false,
        tableData: [],
        excelData:[],
        thisYearData:[],
        lastYearData:[],
        yfDate:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月",],
        wclv:[],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        showPage:true,
        details:[],
        totalLimitMoney:'',
        toTalAmount:'',
        lToTalAmount:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

      }
    },
    components:{
        vPagination,
        Loading,
        date6,
        date7,
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        state:function(state){
            if(state==2)
            {
              return "限制结算50万"
            }
            else{
               return ""
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        },

         company:function(item) {
               if(item==0){
                   return "医药商城"
               }
               else if(item==1){
                   return "汉宁"
               }
               else if(item==2){
                   return "工业"
               }
               else if(item==3){
                   return "西药"
               }
               else if(item==4){
                   return "新特药"
               }
               else if(item==5){
                   return "药品"
               }
               else if(item==6){
                   return "药材"
               }
               else if(item==8){
                   return "连锁药房"
               }
               else if(item==9){
                   return "器材"
               }
         },


        
},

methods: {
      
           //导出查询
      exportExcel() {
                 const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["开始时间","结束时间","公司","今年销售额","去年销售额","查询的今年总的销售","查询的去年总的销售","完成率"]; // 上面设置Excel的表格第一行的标题
                  const filterVal = ['t1','t2','brachNo', 'amount','lAmount','p1','p2','wl']; // 上面的index、nickName、name是tableData里对象的属性key值
                  that.excelData= JSON.parse( JSON.stringify( that.tableData ) ) //深拷贝
                  // [].concat(that.tableData)
                  // [...that.tableData]

                  that.excelData.unshift({t1:that.searchForm.DateMoreThan,t2:that.searchForm.DateLessThan})
                  that.excelData.push({p1:that.toTalAmount,p2:that.lToTalAmount})
                  that.excelData.forEach((item)=>{
                       item.wl=((item.amount/item.lAmount)*100).toFixed(2)+"%"
                        if(item.brachNo==0){
                          item.brachNo="医药商城"
                        }
                        else if(item.brachNo==1){
                            item.brachNo= "汉宁"
                        }
                        else if(item.brachNo==2){
                            item.brachNo= "工业"
                        }
                        else if(item.brachNo==3){
                            item.brachNo= "西药"
                        }
                        else if(item.brachNo==4){
                            item.brachNo= "新特药"
                        }
                        else if(item.brachNo==5){
                            item.brachNo= "药品"
                        }
                        else if(item.brachNo==6){
                            item.brachNo= "药材"
                        }
                        else if(item.brachNo==8){
                            item.brachNo= "连锁药房"
                        }
                        else if(item.brachNo==9){
                            item.brachNo= "器材"
                        }
                        // console.log(item.brachNo)
                     })
                  //  console.log(that.excelData)
                  const list = that.excelData;

                  const data = that.formatJson(filterVal, list);
                  export_json_to_excel(tHeader, data, '销售汇总');//最后一个是表名字
                })
              },
              formatJson(filterVal, jsonData) {
			  
                return jsonData.map(
                    v => filterVal.map(
                      j => v[j]
                      )
				           )
              },



       // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
              getFirstDay(){
                            var today = new Date();　
                            var tYear = today.getFullYear();　　
                            var tMonth = today.getMonth();　　
                            tMonth = this.doHandleMonth(tMonth + 2);
                          //  console.log(tMonth)
               
                          this.searchForm.DateMoreThan=""+ tYear + tMonth + "01";    
              },
              getYearDay(){
				 var today = new Date();　
				  var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
				  tMonth = this.doHandleMonth(tMonth + 1);
				   this.searchForm.DateLessThan =""+tYear  + "01" + "01";
			},
             
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
               getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
  
     //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
         this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
        //   console.log(time)
          this.searchForm.DateMoreThan1=date;
      },   

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },

      getSaletotalbyyear:async function(){
          const that= this
         const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'Saletotalbyyear',
           obj: JSON.stringify({
           
          }) 
        })
        // console.log(res)
        if(res.isok){
             const obj=res.data
                that.lastYearData = obj.lastYearData
                that.thisYearData = obj.thisYearData
                that.thisYearData.forEach((item,index)=>{
                  //  (item.amount/that.lastYearData[index].amount)*100+"%"
                       that.wclv.push(((item.amount/that.lastYearData[index].amount)*100).toFixed(2)+"%")
                })
                  for (let index = that.thisYearData.length; index < 12; index++) {
                      
                        that.thisYearData.push({amount:0})
                        that.wclv.push("0.00%")
                    
                  }
        }

      },
      
    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {



         //获取三个月前的时间戳   时间条件适合才可以查询
        const that = this
        let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();
    //    console.log(seTime2)
        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{

          // if((threeMonthTime<=seTime&&seTime<=todayTime) 
          // && (threeMonthTime<=seTime2&&seTime2<=todayTime)
          // ){

          // this.isLoading=true;
        const { data: res } = await that.$http.post('Dls/getFun', {
          action: 'Saletotalbydate',
          obj: JSON.stringify({
             StartDate:that.searchForm.DateLessThan,
             EndDate:that.searchForm.DateMoreThan,
          }) 
        })
        // console.log(res)
           if(res.isok){
                const obj=res.data
                that.tableData = obj.detail
                that.toTalAmount = obj.toTalAmount
                that.lToTalAmount = obj.lToTalAmount
                if(that.tableData.length>0)
                {
                  that.showPage=true;
                }
                else{
                  that.showPage =false;
                }
                  that.getSaletotalbyyear()
             
           }

          //  }
          // else{
          //   alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          // }

        }
         
      },

  
    },
     mounted(){
    },
     created () {
      // this.searchForm.DateMoreThan=this.getDay1(1)
      this.getFirstDay()
      // this.searchForm.DateLessThan=this.getDay1(-90)
      this.getYearDay()
      this.searchForm.DateLessThan1=this.getDay(-1)
      this.searchForm.DateMoreThan1=this.getDay(0)
        this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .bj_red{
     color:red;
 }
</style>


// WEBPACK FOOTER //
// src/pages/manager/SalesSummary.vue